import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import "./ContactUs.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import ContactUs from "../../Common/ContactUs";
import {Link} from "react-router-dom";

function App() {
  return <X10ContactUsPageMobile {...x10ContactUsPageMobileData} />;
}

export default App;

function X10ContactUsPageMobile(props) {
  const {
    place,
    rectangle99,
    sendAMessage,
    text111,
    frame145Props,
    textInputsNormal3Props,
    textInputsNormal32Props,
    textInputsNormal33Props,
    textInputsNormal34Props,
    button2Props,
    //group2122Props,
  } = props;

  return (
    <div className="cpm-container-center-horizontal">
      <div className="cpm-x10-contact-us-page-mobile screen">
        {/* <Frame145 group86Props={frame145Props.group86Props} iconMenuProps={frame145Props.iconMenuProps} /> */}
        <NavBar/>
        <h1 className="cpm-place cpm-valign-text-middle cpm-typographyheadlineh4-extrabold-24">{place}</h1>
        {/* <img className="cpm-rectangle-99" src={rectangle99} /> */}
        <iframe className="cpm-rectangle-99" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4758.027961564364!2d77.56739558617797!3d13.028810897148835!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1785808f1037%3A0x3e8b84d6688c5383!2sWebuildd!5e0!3m2!1sen!2sin!4v1632809494580!5m2!1sen!2sin"></iframe>
        <div className="cpm-send-a-message cpm-valign-text-middle cpm-typographyheadlineh4-extrabold-24">{sendAMessage}</div>
        <p className="cpm-text-3 cpm-typography-body-smalltext-14-regular">{text111}</p>
        <div className="cpm-frame-205">
          <ContactUs />
          {/* <div className="cpm-frame-1652">
            <TextInputsNormal32 frame122Props={textInputsNormal3Props.frame122Props} />
            <TextInputsNormal32
              className={textInputsNormal32Props.className}
              frame122Props={textInputsNormal32Props.frame122Props}
            />
            <TextInputsNormal32
              className={textInputsNormal33Props.className}
              frame122Props={textInputsNormal33Props.frame122Props}
            />
            <TextInputsNormal32
              className={textInputsNormal34Props.className}
              frame122Props={textInputsNormal34Props.frame122Props}
            />
          </div> */}
         {/* <Link to="/">
            <Button23>{button2Props.children}</Button23>
          </Link>*/}
        </div>
        {/* <Group2122
          group862Props={group2122Props.group862Props}
          group872Props={group2122Props.group872Props}
          group322Props={group2122Props.group322Props}
          frame5Props={group2122Props.frame5Props}
        /> */}
        <Footer />
      </div>
    </div>
  );
}


function Frame145(props) {
  const { group86Props, iconMenuProps } = props;

  return (
    <div className="cpm-frame-145">
      <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
      <IconMenu vector2={iconMenuProps.vector2} vector3={iconMenuProps.vector3} />
    </div>
  );
}


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="cpm-group-86">
      <White src={whiteProps.src} />
      <img className="cpm-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="cpm-white">
      <img className="cpm-vector" src={src} />
    </div>
  );
}


function IconMenu(props) {
  const { vector2, vector3 } = props;

  return (
    <div className="cpm-icon-menu">
      <img
        className="cpm-vector-2"
        src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg"
      />
      <img className="cpm-vector-1" src={vector2} />
      <img className="cpm-vector-1" src={vector3} />
    </div>
  );
}


function TextInputsNormal32(props) {
  const { className, frame122Props } = props;

  return (
    <div className={`cpm-text-inputs-normal-1 ${className || ""}`}>
      <Frame122 className={frame122Props.className}>{frame122Props.children}</Frame122>
    </div>
  );
}


function Frame122(props) {
  const { children, className } = props;

  return (
    <div className={`cpm-frame-1-1 cpm-border-1px-light-grey ${className || ""}`}>
      <div className="cpm-text-i2755876716 cpm-inter-normal-sonic-silver-14px">{children}</div>
    </div>
  );
}


function Button23(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x275595TimelineData);
  }, []);

  return (
    <div className="cpm-x275595 cpm-component cpm-component-wrapper not-ready">
      <div className="cpm-master-button-xb5Q3R">
        <div className="cpm-button-i275595511-do1dJx cpm-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const x275595TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".cpm-x275595",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


// function Group2122(props) {
//   const { group862Props, group872Props, group322Props, frame5Props } = props;

//   return (
//     <div className="cpm-group-212">
//       <div className="cpm-flex-row">
//         <Group8622 group85={group862Props.group85} />
//         <Group872
//           facebookAppSymbolProps={group872Props.facebookAppSymbolProps}
//           facebookAppSymbolProps2={group872Props.facebookAppSymbolProps2}
//           twitterProps={group872Props.twitterProps}
//         />
//       </div>
//       <Group322 {...group322Props} />
//       <Frame5
//         quickLinks={frame5Props.quickLinks}
//         frame140Props={frame5Props.frame140Props}
//         frame1402Props={frame5Props.frame1402Props}
//         frame1403Props={frame5Props.frame1403Props}
//       />
//     </div>
//   );
// }


function Group8622(props) {
  const { group85 } = props;

  return (
    <div className="cpm-group-86-1">
      <div className="cpm-white-1">
        <img
          className="cpm-vector-3"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg"
        />
      </div>
      <img className="cpm-group-85-1" src={group85} />
    </div>
  );
}


function Group872(props) {
  const { facebookAppSymbolProps, facebookAppSymbolProps2, twitterProps } = props;

  return (
    <div className="cpm-group-87">
      <FacebookAppSymbol src={facebookAppSymbolProps.src} />
      <Instagram2 overlapGroup1={facebookAppSymbolProps2.overlapGroup1} vector2={facebookAppSymbolProps2.vector2} />
      <Twitter src={twitterProps.src} />
    </div>
  );
}


function FacebookAppSymbol(props) {
  const { src } = props;

  return (
    <div className="cpm-facebook-app-symbol">
      <img className="cpm-f-1" src={src} />
    </div>
  );
}


function Instagram2(props) {
  const { overlapGroup1, vector2 } = props;

  return (
    <div className="cpm-instagram">
      <div className="cpm-overlap-group" style={{ backgroundImage: `url(${overlapGroup1})` }}>
        <img
          className="cpm-vector-4"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-155@2x.svg"
        />
        <img className="cpm-vector-5" src={vector2} />
      </div>
    </div>
  );
}


function Twitter(props) {
  const { src } = props;

  return (
    <div className="cpm-twitter">
      <img className="cpm-vector-6" src={src} />
    </div>
  );
}


function Group322(props) {
  const { place, overlapGroup, phone, overlapGroup1, vector2, text165, text164, contactWebuildCom } = props;

  return (
    <div className="cpm-group-32">
      <div className="cpm-place-1 cpm-valign-text-middle cpm-typographyheadlineh5-extrabold-20">{place}</div>
      <div className="cpm-flex-row-1">
        <div className="cpm-flex-col">
          <div className="cpm-map-pin-1">
            <div className="cpm-overlap-group-1" style={{ backgroundImage: `url(${overlapGroup})` }}>
              <img
                className="cpm-vector-7"
                src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-21@2x.svg"
              />
            </div>
          </div>
          <div className="cpm-phone" style={{ backgroundImage: `url(${phone})` }}></div>
          <div className="cpm-mail">
            <div className="cpm-overlap-group1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
              <img className="cpm-vector-8" src={vector2} />
            </div>
          </div>
        </div>
        <div className="cpm-flex-col-1">
          <p className="cpm-text-2 cpm-typography-body-smalltext-14-regular">{text165}</p>
          <div className="cpm-flex-col-item cpm-valign-text-middle cpm-typography-body-smalltext-14-regular">{text164}</div>
          <div className="cpm-flex-col-item cpm-valign-text-middle cpm-typography-body-smalltext-14-regular">
            {contactWebuildCom}
          </div>
        </div>
      </div>
    </div>
  );
}


function Frame5(props) {
  const { quickLinks, frame140Props, frame1402Props, frame1403Props } = props;

  return (
    <div className="cpm-frame-5">
      <div className="cpm-quick-links cpm-valign-text-middle cpm-typographyheadlineh5-extrabold-20">{quickLinks}</div>
      <div className="cpm-frame-4">
        <Frame140 aboutUs={frame140Props.aboutUs} projects={frame140Props.projects} />
        <Frame140
          aboutUs={frame1402Props.aboutUs}
          projects={frame1402Props.projects}
          className={frame1402Props.className}
        />
        <Frame140
          aboutUs={frame1403Props.aboutUs}
          projects={frame1403Props.projects}
          className={frame1403Props.className}
        />
      </div>
    </div>
  );
}


function Frame140(props) {
  const { aboutUs, projects, className } = props;

  return (
    <div className={`cpm-frame-140 ${className || ""}`}>
      <div className="cpm-about-us cpm-valign-text-middle cpm-typographybody16-regular">{aboutUs}</div>
      <div className="cpm-projects cpm-valign-text-middle cpm-typographybody16-regular">{projects}</div>
    </div>
  );
}

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-3@2x.svg",
    whiteProps: whiteData,
};

const iconMenuData = {
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
};

const frame145Data = {
    group86Props: group86Data,
    iconMenuProps: iconMenuData,
};

const frame122Data = {
    children: "Comment",
    className: "",
};

const textInputsNormal32Data = {
    frame122Props: frame122Data,
};

const frame1222Data = {
    children: "Name (Required)",
    className: "cpm-frame-1-2",
};

const textInputsNormal322Data = {
    className: "cpm-text-inputs-normal",
    frame122Props: frame1222Data,
};

const frame1223Data = {
    children: "Email (Required)",
    className: "cpm-frame-1-3",
};

const textInputsNormal323Data = {
    className: "cpm-text-inputs-normal",
    frame122Props: frame1223Data,
};

const frame1224Data = {
    children: "Phone Number  (Required)",
    className: "cpm-frame-1",
};

const textInputsNormal324Data = {
    className: "cpm-text-inputs-normal",
    frame122Props: frame1224Data,
};

const button23Data = {
    children: "SEND MESSAGE",
};

const group8622Data = {
    group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-17@2x.svg",
};

const facebookAppSymbolData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-1@2x.svg",
};

const instagram2Data = {
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-154@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-19@2x.svg",
};

const twitterData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-157@2x.svg",
};

const group872Data = {
    facebookAppSymbolProps: facebookAppSymbolData,
    facebookAppSymbolProps2: instagram2Data,
    twitterProps: twitterData,
};

const group322Data = {
    place: "Contact",
    overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-20@2x.svg",
    phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-151@2x.svg",
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-152@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-153@2x.svg",
    text165: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
    text164: "+91 8976535221, +91 8755645342",
    contactWebuildCom: "contact@webuild.com",
};

const frame140Data = {
    aboutUs: "About Us",
    projects: "Projects",
};

const frame1402Data = {
    aboutUs: "Gallery",
    projects: "Knowledge Transfer",
    className: "cpm-frame-14-1",
};

const frame1403Data = {
    aboutUs: "Blogs",
    projects: "FAQ’s",
    className: "cpm-frame-14",
};

const frame5Data = {
    quickLinks: "Quick Links",
    frame140Props: frame140Data,
    frame1402Props: frame1402Data,
    frame1403Props: frame1403Data,
};

// const group2122Data = {
//     group862Props: group8622Data,
//     group872Props: group872Data,
//     group322Props: group322Data,
//     frame5Props: frame5Data,
// };

const x10ContactUsPageMobileData = {
    place: "Contact",
    rectangle99: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-99-1@2x.png",
    sendAMessage: "Send a message",
    text111: "There are many variations of passages of Lorem Ipsum available but the majority have suffered dummy alteration in that an some form by the injected humour or randomised words which don’t look even that slightly believable. If you are Lorem Ipsums your need to be sure there isn’t anything embarrassing.",
    frame145Props: frame145Data,
    textInputsNormal3Props: textInputsNormal32Data,
    textInputsNormal32Props: textInputsNormal322Data,
    textInputsNormal33Props: textInputsNormal323Data,
    textInputsNormal34Props: textInputsNormal324Data,
    button2Props: button23Data,
    //2Props: group2122Data,
};

